import { Switch } from '@innovationnorway/cl-react';
import React from 'react';
import { useParams } from 'react-router-dom';
import ContentPage from 'src/components/ContentPage/ContentPage';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import NotFoundPage from 'src/components/NotFoundPage/NotFoundPage';
import { useSivaGoalsDetails } from '../../hooks/use-siva-goals-details';
import SivaGoalTag from '../components/SivaGoalTag';
import SivaGoalsList from '../components/SivaGoalsList';
import SivaGoalsReviewButtons from '../components/SivaGoalsReviewButtons';
import { SivaGoalsStatus } from 'src/api/v2';
const SivaAdminGoalsDetailsPage: React.FC = () => {
  const { year, clusterId } = useParams();
  const current = useSivaGoalsDetails(clusterId, year ? parseInt(year) : undefined);
  const prev = useSivaGoalsDetails(clusterId, year ? parseInt(year) - 1 : undefined);
  const isLoading = current.isLoading || prev.isLoading;
  const yearNum = year ? parseInt(year) : undefined;
  const [wantsToReviseReview, setWantsToReviseReview] = React.useState<boolean>(false);
  const hasBeenReviewed = React.useMemo(
    () =>
      (current.data?.goalsStatus === SivaGoalsStatus.Approved ||
        current.data?.goalsStatus === SivaGoalsStatus.ChangeRequested) &&
      !wantsToReviseReview,
    [current.data?.goalsStatus, wantsToReviseReview],
  );
  const [showCommentedOnly, setShowCommentedOnly] = React.useState<boolean>(
    current.data?.goalsStatus === SivaGoalsStatus.ChangeRequested,
  );
  const [sivaHasSubmittedComment, setSivaHasSubmittedComment] = React.useState(false);
  const sivaHasContentOnServer =
    current?.data?.goalAccomplishments.some((it) => it.sivaComment != undefined) ?? false;
  if (isLoading) {
    return <LoadingPage />;
  }
  if (!year || !clusterId || !current.data || yearNum === undefined) {
    return <NotFoundPage />;
  }
  return (
    <ContentPage
      title={current.data.clusterName}
      breadcrumbLeaf={current.data.clusterName}
      documentTitle={`Måltall ${year} for ${current.data.clusterName}`}
      titleAdornment={<SivaGoalTag status={current.data.goalsStatus} />}
    >
      <Switch
        checked={showCommentedOnly}
        label={showCommentedOnly ? 'Viser kun kategorier Siva har kommentert på' : 'Viser alle måltall'}
        onChange={() => {
          setShowCommentedOnly(!showCommentedOnly);
        }}
      />

      <SivaGoalsList
        clusterId={clusterId}
        year={yearNum}
        currentYear={current?.data}
        previousYear={prev?.data}
        readMode={hasBeenReviewed}
        showCommentedOnly={showCommentedOnly}
        setSivaHasSubmittedComment={setSivaHasSubmittedComment}
      />

      <SivaGoalsReviewButtons
        clusterId={clusterId}
        year={yearNum}
        hasBeenReviewed={hasBeenReviewed}
        setWantsToReviseReview={setWantsToReviseReview}
        sivaHasCommented={sivaHasContentOnServer || sivaHasSubmittedComment}
      />
    </ContentPage>
  );
};
export default SivaAdminGoalsDetailsPage;
